// aiModelName — Central resolver för model-namnet som rapporteras till
// `aiOps.modelUsed` efter en lyckad AI-stream.
//
// Default-modellen speglar den som `supabase/functions/ai-workflow-
// assistant/index.ts` hårdkodar. Vid config-drift måste båda ändras
// (täcks av schema/snapshot-tester när vi lägger en i framtida scan).
//
// Se IMPROVEMENTS.md A-010 (subset).

/**
 * Den hårdkodade modellen som `ai-workflow-assistant`-edge-funktionen
 * skickar till Lovable-gateway. Exponerad så emit-sidan (dialog) kan
 * rapportera samma sträng till `ai_ops_event`.
 */
export const AI_DEFAULT_EDGE_MODEL = 'google/gemini-3-flash-preview';

/**
 * Returnerar den model-sträng som ska skickas in i `aiOps.modelUsed`.
 *
 * - Vid custom endpoint: user-configurerad model, fallback 'custom' om
 *   user lämnat fältet tomt (endpoint-servern väljer själv modell).
 * - Vid default edge-funktion: hårdkodat `AI_DEFAULT_EDGE_MODEL`.
 */
export function resolveEmittedModelName(
  isCustomEndpoint: boolean,
  customModel?: string | null,
): string {
  if (isCustomEndpoint) {
    const trimmed = (customModel ?? '').trim();
    return trimmed.length > 0 ? trimmed : 'custom';
  }
  return AI_DEFAULT_EDGE_MODEL;
}
